import { makeVar } from "@apollo/client";

export const monthVar = makeVar<string | null | undefined>(null);
export const tabVar = makeVar<string | null | undefined>(null);
export const trendDurationVar = makeVar<string | null | undefined>(null);
export const viewVar = makeVar<string | null | undefined>(null);
export const yearVar = makeVar<string | null | undefined>(null);

/*
request.getParameter(xxx)
TODO event.getRequestParameter(xxx) + others in HttpEvent


template
- com.adcon.livedata.common.LiveDataContext
- com.adcon.livedata.instruments.common.InstrumentServlet

beginDate, endDate
- com.adcon.livedata.instruments.common.InstrumentServlet

method
- com.adcon.livedata.instruments.common.InstrumentServlet

month, year
- com.adcon.livedata.panels.overview.OverviewTabBean
- com.adcon.livedata.export.CSVExportServlet

moreevents
- EventFilterUtil

node
- com.adcon.livedata.panels.PivotPanelBean
- com.adcon.livedata.panels.WindrosePanelBean
- com.adcon.livedata.panels.overview.CropOverviewTabBean
- com.adcon.livedata.common.FloodMonitoringListItem
- com.adcon.livedata.common.ListItem
- com.adcon.livedata.common.WeatherTajListItem
- com.adcon.livedata.util.floodmonitoring.FloodMonitoringUtil

pivotDuration
- com.adcon.livedata.panels.mccrometer.McCrometerPivotTabBean

previousNodes
- com.adcon.livedata.common.LiveDataBaseBean

tab
- com.adcon.livedata.collections.common.PanelCollectionBean
- com.adcon.livedata.collections.common.TabManager
- com.adcon.livedata.panels.AbstractPanelBean

trendduration
- com.adcon.livedata.panels.AbstractPanelBean
- com.adcon.livedata.instruments.common.InstrumentServlet

view
- com.adcon.livedata.panels.overview.OverviewTabBean



maptype, north, east, south, west
- com.adcon.livedata.map.MapBean



"RequestUtils"
- node, locale, units

"com.adcon.livedata.util.URLConstructor"
- MULTIPLE

 */
